import { Modal } from "@/frontend/shared/ui/Modal";
import { Typography } from "@/frontend/shared/ui/Typography";
import { UploadImage } from "@/frontend/shared/ui/UploadImage/UploadImage";
import styles from "./ProfilePictureModal.module.scss";

export function ProfilePictureModal({
  isOpen,
  onClose,
  onUpload,
  onUploadFile,
  image,
  onRemove,
  isLoading
}: {
  isOpen: boolean;
  onClose: () => void;
  onUpload: (image: string | null) => void;
  onUploadFile: (file: File | null) => void;
  onRemove: () => void;
  image: string;
  isLoading: boolean;
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Profile Picture">
      <Typography variant="body-2" color="greyscale700">
        A picture helps people recognize you and lets you know when you're signed in to your account
      </Typography>
      <div className={styles.container}>
        <UploadImage
          onUpload={onUpload}
          onUploadFile={onUploadFile}
          image={image}
          onRemove={onRemove}
          isLoading={isLoading}
        />
        <div className={styles.buttonsContainer}></div>
      </div>
    </Modal>
  );
}
